/**
 * InsolationOnboarding — content for the Insolation mode onboarding panel.
 *
 * Pure presentational component: renders the title, body and dismiss button.
 * Visibility and sessionStorage persistence are handled by OnboardingContext /
 * OnboardingOverlay — this component only needs to call closeOnboarding() on dismiss.
 */
import { useState } from 'react'

import { useI18n } from '../../../../shared/i18n/useI18n.js'

import { HotspotMode }  from '../../../../shared/ui/icons/index.js'

import styles from './HotSpotOnboarding.module.scss'
import pane_styles from './OnboardingOverlay.module.scss' // for shared styles like .title

export function HotSpotOnboarding({isMobile, loadExpanded = false}) {
  const { t } = useI18n()
  const [expanded, setExpanded] = useState(loadExpanded)

  return (
    <div className={pane_styles.content}>
      <h3 className={pane_styles.title}><HotspotMode /> {t('product.hot_spot_onboarding_title')}</h3>
      <p className={pane_styles.body}>{t('product.hot_spot_onboarding_par1')}</p>
      <p className={pane_styles.cta}>{t('product.hot_spot_onboarding_cta')}</p>
      <p className={pane_styles.disclaimer}>{t('product.hot_spot_onboarding_disclaimer')}</p>
      {/* <span
        className={pane_styles.cta}
        onClick={() => setExpanded((e) => !e)}
        style={{ cursor: 'pointer' }}
      >
        {expanded ? t('product.onboarding_hide_details') : t('product.onboarding_learn_more')}
      </span> */}
    </div>
  )
}


